import {
  ImageCheckbox,
  ListItemImage,
  MainImageMessage,
} from "../styles/styles";
import { ArrowCounterClockWise } from "../Atoms/Icons/ArrowCounterClockWise";
import { Image } from "../types/images";
import { useGetMediaImageSignedUrl } from "../hooks/useGetMediaImageSignedUrl";
import { useTranslation } from "@coworker/locales";
import React from "react";

interface MediaImageItemProps {
  image: Image;
  index: number;
  setSelectImage: (images: string[]) => void;
  onUpdate: (image: Image) => void;
  selectImage: string[];
  selectButtonClick: boolean;
  mainImage?: boolean;
}

export const MediaImageItem = ({
  image,
  index,
  setSelectImage,
  onUpdate,
  selectImage,
  mainImage = false,
}: MediaImageItemProps) => {
  const { t } = useTranslation();
  const { data: imageUrl, isLoading } = useGetMediaImageSignedUrl(
    image?.fileName ?? "",
    "small"
  );

  const handleSelectedImage = (imageId: string) => {
    if (selectImage.includes(imageId)) {
      setSelectImage(selectImage.filter((id) => id !== imageId));
    } else {
      setSelectImage([...selectImage, imageId]);
    }
  };

  const handleRotateImage = async (
    image: Image,
    index: number
  ): Promise<void> => {
    image.rotation = image.rotation ? (image.rotation + 90) % 360 : 90;
    const carouselImage = document.getElementById(`${image.id}-${index}`);
    if (carouselImage) {
      carouselImage.style.transform = "rotate(" + image.rotation + "deg)";
    }

    onUpdate(image);
  };

  return (
    <div style={{ position: "relative" }} key={index}>
      <React.Fragment>
        {!isLoading && (
          <ListItemImage
            id={`${image.id}-${index}`}
            key={image?.id ?? ""}
            src={imageUrl?.urls?.[0] ?? ""}
            $rotation={image.rotation || 0}
            $isMain={mainImage}
          />
        )}
        {mainImage && (
          <MainImageMessage
            $isMain={mainImage}
            message={t("mainImageString")}
          />
        )}
        <div
          onClick={() => {
            void handleRotateImage(image, index);
          }}
        >
          <ArrowCounterClockWise />
        </div>
      </React.Fragment>
      {image.id && (
        <ImageCheckbox
          id={image.id || ""}
          value={image.id || ""}
          checked={selectImage.includes(image.id || "")}
          onChange={() => {
            handleSelectedImage(image.id || "");
          }}
        />
      )}
    </div>
  );
};
